import axios from "axios";
import { Notify } from "quasar";

import { useColor } from "src/composables/color";
import { ICON_PATH } from "assets/scripts/utilities/constants";

const CancelToken = axios.CancelToken;

const api = axios.create({
  baseURL: import.meta.env.CLIENT_BASE_URL,
  formSerializer: {
    indexes: true,
  },
  withCredentials: true,
  xsrfCookieName: "POSHN-XSRF-TOKEN",
});

const searchApi = axios.create({
  baseURL: import.meta.env.CLIENT_SEARCH_API_DOMAIN,
  formSerializer: {
    indexes: true,
  },
  withCredentials: true,
  xsrfCookieName: "POSHN-XSRF-TOKEN",
});

const conversationsApi = axios.create({
  baseURL: import.meta.env.CLIENT_CONVERSATION_API_DOMAIN,
  formSerializer: {
    indexes: true,
  },
  withCredentials: true,
  xsrfCookieName: "POSHN-XSRF-TOKEN",
});

const notify = (notification) => {
  let type = notification.type || "info";
  const color = useColor();
  const notificationConfig = {
    position: "top",
    timeout: 5000,
    type,
    ...color(type),
    ...notification,
  };

  if (ICON_PATH[type]) {
    notificationConfig.icon = ICON_PATH[type];
  }

  Notify.create(notificationConfig);
};

const showGenericToast = (response, type = "info") => {
  let message = response?.data?.message;

  if (message) {
    message = Array.isArray(message)
      ? message.map((msg) => msg.msg).join(", ")
      : message;

    const notificationConfig = {
      message,
      type: type,
    };

    notify(notificationConfig);
  }
};

const errorLogger = (error) => {
  if (error.response) {
    console.log("%cRESPONSE ERROR:", "color:red");

    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log("DATA:");

    console.log(error.response.data);

    console.log("STATUS:", error.response.status);

    console.log("HEADERS:");

    console.log(error.response.headers);

    showGenericToast(error.response, "negative");
  } else if (error.request) {
    console.log("%cREQUEST ERROR:", "color:red");

    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request);
  } else {
    console.log("%cREQUEST SETUP ERROR:", "color:red");

    // Something happened in setting up the request that triggered an Error
    console.error(error);
  }

  console.log("%cREQUEST CONFIG:", "color:yellow");

  console.log(error.config);
};

export {
  api,
  searchApi,
  conversationsApi,
  CancelToken,
  notify,
  errorLogger,
  showGenericToast,
};
